import { HttpInterceptorFn } from '@angular/common/http';
import { rewriteApiUrl } from '../_util/data-target';

/**
 * Routes every canonical `/api/...` call to the backend of the selected data target
 * (`/api-prod/...` or `/api-dev/...`). Must be the LAST interceptor so that all the others still
 * see the canonical `/api/...` URL (e.g. the error reporter's skip list).
 */
export const dataTargetInterceptor: HttpInterceptorFn = (req, next) => {
  const url = rewriteApiUrl(req.url);
  return next(url === req.url ? req : req.clone({ url }));
};
